import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

export const namespace = 'blogArticleImageEditor';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

const initialFormValues = {
	title: '',
	language: [],
	image: null
};

function mapResponseDataToStateData(data) {
	return {
		title: data.title,
		image: {
			blob: data.image,
			file: null
		},
		language: [{
			value: data.language,
			label: data.language
		}]
	};
}

function getCreateRequest({ title, language, image }) {
	const data = new FormData();

	data.append('title', title);
	data.append('language', language);
	data.append('image', image && image.file);

	return http({
		url: endpoints.BLOG.ARTICLE_IMAGES,
		method: 'post',
		actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
		data
	});
}

function getUpdateRequest(imageId, { title, language }) {
	const data = { title, language };

	return http({
		url: `${endpoints.BLOG.ARTICLE_IMAGES}/${imageId}`,
		method: 'put',
		actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
		data
	});
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const imageId = props.params.id;

			if (!imageId) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: `${endpoints.BLOG.ARTICLE_IMAGES}/${imageId}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch) => {
			const payload = { ...values, language: values.language[0].value };

			const imageId = props.params.id;

			dispatch(actions.own.toggleProgressBar());

			const request = imageId
				? getUpdateRequest(imageId, payload)
				: getCreateRequest(payload);

			return request(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getLanguages: (state) => state.root.lists['languages']
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-image/editor/index.js